import concat from 'lodash/concat';
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

import type { VoyageDataResponse, VoyagesDataRegionPackage } from '@/infra/types/voyageInfo/package';

export const getRegionPackagesGroupedByName = (regionPackages: VoyagesDataRegionPackage[]) => {
  const packages = sortBy(
    regionPackages.reduce<VoyagesDataRegionPackage[]>(
      (items, item) =>
        item.id && item.name
          ? [
              ...items,
              {
                ...item,
                name: item.name.trim(),
              },
            ]
          : items,
      [],
    ),
    ['name', 'id'],
  );

  return Object.values(groupBy([...new Map(packages.map((m) => [m.id, m])).values()], 'name'));
};

export const calculateAdditonalVoyagesData = (voyagesData: VoyageDataResponse) => ({
  mapPackageCodeToAltPackageCodes: voyagesData.regions.reduce<Record<string, string[]>>((altCodes, region) => {
    if (!region.navigationOrder) {
      return altCodes;
    }

    return {
      ...altCodes,
      ...getRegionPackagesGroupedByName(region.packages).reduce(
        (altCodes, items) => ({
          ...altCodes,
          [items[0]!.id!]: items.map(({ id }) => id),
        }),
        {},
      ),
    };
  }, {}),
  mapPackageCodeToRegionIds: voyagesData.regions.reduce<Record<string, string[]>>((result, region) => {
    const packageCodeToRegionId = region.packages.reduce<Record<string, string[]>>((ids, { id }) => {
      if (id && ids[id]) {
        return { ...ids, [id]: [...ids[id]!, region.id] };
      }
      return id ? { ...ids, [id]: [region.id] } : ids;
    }, result);
    return {
      ...result,
      ...packageCodeToRegionId,
    };
  }, {}),
  mapPortOfCallCodeToRegionIds: voyagesData.regions.reduce<Record<string, string[]>>((result, region) => {
    const portCodeToRegionId = concat(...Object.values(region.portsOfCall)).reduce<Record<string, string[]>>(
      (codes, { code }) => {
        if (code && codes[code]) {
          return { ...codes, [code]: [...codes[code]!, region.id] };
        }

        return code ? { ...codes, [code]: [region.id] } : codes;
      },
      result,
    );

    return {
      ...result,
      ...portCodeToRegionId,
    };
  }, {}),
});
